enum CurrencyType {
    NGN = "NGN",
    CAD = "CAD",
    USD = "USD",
    INR = "INR"
}

export default {
    CurrencyType
}